import { Form, Modal } from "react-bootstrap";
import { useEffect } from "react";
import { Grid } from "@mui/material";
import { Box } from "@mui/material";
import { useForm } from "react-hook-form";
import FormActions from "../../../../components/Formularios/Buttons/FormActions";
import CustomTextField from "../../../../components/Formularios/Inputs/CustomTextField";
import SwitchAtivo from "../../../../components/Formularios/Inputs/SwitchAtivo";

interface DetalheFormData {
  codigo: string;
  descricao: string;
  ativo: boolean;
  defUsuario01?: string;
  defUsuario02?: string;
  defUsuario03?: string;
  defUsuario04?: string;
  defUsuario05?: string;
  defUsuario06?: string;
}

interface DetalheModalProps {
  showModal: boolean;
  acao?: string;
  onClose: () => void;
  dadosCodigo?: string;
  dadosDescricao?: string;
  dadosAtivo?: boolean;
  dadosDefUsuario01?: string;
  dadosDefUsuario02?: string;
  dadosDefUsuario03?: string;
  dadosDefUsuario04?: string;
  dadosDefUsuario05?: string;
  dadosDefUsuario06?: string;
  onSubmit: (formData: any) => void;
}

const titulosPorAcao: Record<string, string> = {
  Novo: "Incluir Código do Sistema",
  EditarItem: "Editar Código do Sistema",
  Visualizar: "Visualizar Código do Sistema",
};

const camposDefUsuario = [
  "defUsuario01",
  "defUsuario02",
  "defUsuario03",
  "defUsuario04",
  "defUsuario05",
  "defUsuario06",
] as const;

const ModalDetalhe: React.FC<DetalheModalProps> = ({
  showModal,
  acao,
  onClose,
  dadosCodigo,
  dadosDescricao,
  dadosAtivo,
  dadosDefUsuario01,
  dadosDefUsuario02,
  dadosDefUsuario03,
  dadosDefUsuario04,
  dadosDefUsuario05,
  dadosDefUsuario06,
  onSubmit,
}) => {
  const { register, handleSubmit, reset, control } = useForm<DetalheFormData>({
    defaultValues: {
      codigo: "",
      descricao: "",
      ativo: true,
      defUsuario01: "",
      defUsuario02: "",
      defUsuario03: "",
      defUsuario04: "",
      defUsuario05: "",
      defUsuario06: "",
    }
  });

  const isVisualizando = acao === "Visualizar";

  const carregarDados = () => {
    reset({
      codigo: dadosCodigo || "",
      descricao: dadosDescricao || "",
      ativo: dadosAtivo === true,
      defUsuario01: dadosDefUsuario01 || "",
      defUsuario02: dadosDefUsuario02 || "",
      defUsuario03: dadosDefUsuario03 || "",
      defUsuario04: dadosDefUsuario04 || "",
      defUsuario05: dadosDefUsuario05 || "",
      defUsuario06: dadosDefUsuario06 || "",
    });
  };

  useEffect(() => {
    if (showModal) {
      carregarDados();
    }
  }, [showModal]);

  const handleFormSubmit = (data: DetalheFormData) => {
    onSubmit({
      ...data,
      acao,
    });
  };

  return (
    <>
      <Modal
        show={showModal}
        className="modal-full-width"
        size="xl"
        keyboard={false}
        centered
      >
        <Modal.Header className="bg-white">
          <Modal.Title>{titulosPorAcao[acao ?? ""] ?? "Código do Sistema"}</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit(handleFormSubmit)}>
          <Modal.Body className="bg-white">
            <Box sx={{ width: "100%", pt: 1 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={2}>
                  <CustomTextField
                    label="Código"
                    name="codigo"
                    register={register}
                    rules={{ required: true }}
                    required
                    disabled={isVisualizando || acao === "EditarItem"}
                    inputProps={{
                      style: { textTransform: 'uppercase' }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={8}>
                  <CustomTextField
                    label="Descrição"
                    name="descricao"
                    register={register}
                    rules={{ required: true }}
                    required
                    disabled={isVisualizando}
                    inputProps={{
                      style: { textTransform: 'capitalize' }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <SwitchAtivo
                    name="ativo"
                    control={control}
                    valorLigado={true}
                    valorDesligado={false}
                    disabled={isVisualizando}
                  />
                </Grid>
                {camposDefUsuario.map((campo, index) => (
                  <Grid item xs={12} sm={4} key={campo}>
                    <CustomTextField
                      label={`Def. Usuário 0${index + 1}`}
                      name={campo}
                      register={register}
                      disabled={isVisualizando}
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Modal.Body>
          <Modal.Footer className="bg-white">
            <FormActions onVoltar={onClose} visualizar={isVisualizando} variante="modal" />
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};
export default ModalDetalhe;
